export const TransactionDataKeyMap = {
  refNum: 'Transaction #',
  extData_BatchNum: 'Batch #',
  extData_EDCTYPE: 'Card Type',
};
